import React from "react"; // eslint-disable-line no-unused-vars
import { Button } from "@mui/material";
import { useAuth0, PopupLoginOptions } from "@auth0/auth0-react";
import * as consts from "../utilities/consts";

export interface SignUpLinkProps {
  disabled?: boolean;
  label?: string;
}

export const SignUpLink = ({
  disabled = false,
  label = "Sign Up",
}: SignUpLinkProps): React.JSX.Element | null => {
  const { isAuthenticated, loginWithPopup } = useAuth0();

  if (isAuthenticated) {
    return null;
  } else {
    return (
      <Button
        sx={{ display: "inline-block", margin: "8px" }}
        variant="outlined"
        className="tb_secondary_button"
        onClick={() => {
          if (!disabled) {
            let popupLoginOptions: PopupLoginOptions = {
              authorizationParams: {
                redirect_uri: window.location.href,
                audience: consts.AUTH0_AUDIENCE,
                responseType: "id_token token",
                scope: consts.AUTH0_SCOPE,
                screen_hint: "signup",
              },
            };

            loginWithPopup(popupLoginOptions);
            //This should redirect to a profile style page that collects users info and creates an Auth0 account for them
          }
        }}
      >
        {label}
      </Button>
    );
  }
};
